import { useCallback, useContext, useEffect, useMemo, useState } from "react"
import dataApplicationsContext, { FILTER_VALUES } from "../../context/dataApplicationsContext"
import { useGetAllPaymentMethodsQuery, useGetAllSeasonsQuery, useGetAllTarifsQuery } from "../../slices/inscriptionsApiSlice";
import Select from 'react-select';
import { useGetAllUsersQuery, useUpdateReviewReasonMutation, useUpdateUserSeasonGroupMutation, useUpdateUserSeasonLicenceMutation } from "../../slices/usersApiSlice";
import { SyncLoader } from "react-spinners";
import TableBloc from "../../components/TableBloc";
import FormNewUSer from "./FormNewUSer";
import { useGetAllGroupsQuery } from "../../slices/groupsApiSlice";
import MobileEffective from "./MobileEffective";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FilterRows from "../../components/FilterRows";

export const getDefaultLicenceDisplay = (item) => {
  if (item.season_licence) return item.season_licence;
  if (item.licence) return `En attente --- ${item.licence}`;
  return '';
};

const Effectifs = ({ isAdmin }) => {
  const { 
    openSidebar, windowWidth, openModalNewUser, setOpenModalNewUser, edittingUser, setEdittingUser, isComingFromRecap,
    selectedSeason, setSelectedSeason, filterOnglet, setFilterOnglet
  } = useContext(dataApplicationsContext);

  const [options, setOptions] = useState([]);
  const [filterGroup, setFilterGroup] = useState(null);
  const [filterTarif, setFilterTarif] = useState(null);
  const [search, setSearch] = useState('');
  const [displayUsers, setDisplayUsers] = useState([]);
  const [kpiUsers, setKpiUsers] = useState([]);
  const [pendingLicences, setPendingLicences] = useState({}); // { [id_user_season]: newValue }
  const [isSavingLicences, setIsSavingLicences] = useState(false);
  
  const [updateUserSeasonLicence] = useUpdateUserSeasonLicenceMutation();
  const [updateUserSeasonGroup] = useUpdateUserSeasonGroupMutation();
  const [updateReviewReason] = useUpdateReviewReasonMutation();
  
  const navigate = useNavigate();

  const { data: seasons, isLoading, isSuccess } = useGetAllSeasonsQuery(); 
  const { data: tarifs, isLoading: isLoadingTarifs, isSuccess: isSuccessTarifs } = useGetAllTarifsQuery(
    selectedSeason?.value, { skip: !selectedSeason }
  ); 
  const { data: users, isLoading: isLoadingUser, isSuccess: isSuccessUser, refetch } = useGetAllUsersQuery(
    selectedSeason?.value, { skip: !selectedSeason }
  ); 
  const { data: paymentMethods, isLoading: isLoadingpaymentMethods, isSuccess: isSuccesspaymentMethods } = useGetAllPaymentMethodsQuery(); 
  const { data: groups, isLoading: isLoadingGroups, isSuccess: isSuccessGroups } = useGetAllGroupsQuery(selectedSeason?.value, { skip: !selectedSeason }); 

  const optionGroups = useMemo(() => {
    if (!isSuccessGroups) return [];
    return groups.map(group => ({ label: group.lib_group, value: group.id_group }));
  }, [isSuccessGroups, groups])

  const optionTarifs = useMemo(() => {
    if (!isSuccessTarifs) return [];
    return tarifs.map(tarif => ({ label: tarif.lib_tarif, value: tarif.id_tarif }));
  }, [isSuccessTarifs, tarifs])

  useEffect(() => {
    if (isSuccess) {
      setOptions(seasons.map(season => ({ label: season.lib_season, value: season.id_season })));
      setSelectedSeason({ label: seasons[0].lib_season, value: seasons[0].id_season })
    }
  }, [isSuccess])


  const getFraternityFinalRemaining = (user, list) => {
    if (!user.id_fraternity) return user.remaining_amount;
    const firstIndex = list.findIndex(u => u.id_fraternity === user.id_fraternity);
    const firstUser = list[firstIndex];
    let total = 0;
    for (let i = firstIndex; i < list.length; i++) {
      if (list[i].id_fraternity === user.id_fraternity) {
        total += list[i].remaining_amount;
      } else {
        break;
      }
    }
    return total - parseInt(firstUser.discount_fratrie, 10);
  };

  
  useEffect(() => {
    if (isSuccessUser) {
      // 1. Base commune : groupe / tarif / recherche (SANS l'onglet)
      let baseFiltered = users;

      if (filterGroup) {
        baseFiltered = baseFiltered.filter(u => u.groups?.some(g => g.id_group === filterGroup.value));
      }
      if (filterTarif) {
        baseFiltered = baseFiltered.filter(u => u.id_tarif === filterTarif.value);
      }

      if (search.length > 0) {
        const normalizeString = (str) =>
          str?.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

        const normalizedSearch = normalizeString(search);
        const includesSearch = (str) => normalizeString(str)?.includes(normalizedSearch);

        baseFiltered = baseFiltered.filter((user) =>
          includesSearch(user.last_name)
          || includesSearch(user.first_name)
          || includesSearch(user.birth_date.split('T')[0])
          || includesSearch(user.adresse)
          || includesSearch(user.email)
          || includesSearch(user.email_2)
        );
      }

      // Cette base sert de référence stable pour les compteurs des onglets
      setKpiUsers(baseFiltered);

      // 2. Filtre onglet appliqué EN PLUS, uniquement pour l'affichage du tableau
      let usersToDisplay;

      if (filterOnglet === FILTER_VALUES['unpaids']) {
        usersToDisplay = baseFiltered.filter(u => getFraternityFinalRemaining(u, baseFiltered) > 0);
      } else if (filterOnglet === FILTER_VALUES['partials']) {
        usersToDisplay = baseFiltered.filter(u => u.gender === 'NC');
      } else if (filterOnglet === FILTER_VALUES['refunds']) {
        usersToDisplay = baseFiltered.filter(u => getFraternityFinalRemaining(u, baseFiltered) < 0);
      } else if (filterOnglet === FILTER_VALUES['reviews']) {
        usersToDisplay = baseFiltered.filter(u => u.needs_review);
      } else {
        usersToDisplay = baseFiltered;
      }

      setDisplayUsers(usersToDisplay);
    }
  }, [search, isSuccessUser, users, filterOnglet, filterGroup, filterTarif]);

  const handleSelect = (option, setter) => {
    setter(option)
  }

  const handleCloseModal = useCallback(() => {
    setOpenModalNewUser(false);
    setEdittingUser(null);
    if (isComingFromRecap) {
      navigate('/recap')
    } 
  }, [openModalNewUser]);

  const handleCancelLicences = () => {
    setPendingLicences({});
  };

  const handleLicenceChange = (item, value) => {
    const defaultValue = getDefaultLicenceDisplay(item);
    setPendingLicences(prev => {
      const updated = { ...prev };
      if (value === defaultValue) {
        // retour à la valeur d'origine → on retire du cache
        delete updated[item.id_user_season];
      } else {
        updated[item.id_user_season] = value;
      }
      return updated;
    });
  };

  const hasPendingLicenceChanges = Object.keys(pendingLicences).length > 0;

  const handleSaveLicences = async () => {
    setIsSavingLicences(true);
    try {
      await Promise.all(
        Object.entries(pendingLicences).map(([id_user_season, season_licence]) =>
          updateUserSeasonLicence({ id_user_season: Number(id_user_season), season_licence }).unwrap()
        )
      );
      toast.success("Licences mises à jour", { autoClose: 1000, hideProgressBar: true });
      setPendingLicences({});
      refetch();
    } catch (error) {
      console.log(error);
      toast.error("Erreur lors de l'enregistrement des licences");
    } finally {
      setIsSavingLicences(false);
    }
  };


  if (isLoading || isLoadingUser || isLoadingTarifs || isLoadingpaymentMethods || isLoadingGroups) {
    return <SyncLoader color='#e1004a' size={12} className="mt-16 pl-48"/>
  }

  const headers = [
    { label: 'Licence', value: 'licence', colClass: 'md' },
    { label: 'Groupe', value: 'group', colClass: 'lg' },
    // { label: 'Date Licence', value: 'licence_date', colClass: 'sm' },
    { label: 'Téléphones', value: 'telephones', isArray: true, colClass: 'lg', 
      subAttributes: { id: 'id_telephone', lib: 'lib_telephone', value: 'phone_number'}
    },
    // { label: 'Allergies', value: 'allergies', isArray: true, colClass: 'sm', 
    //   subAttributes: { id: 'id_allergie', value: 'allergie_value'}
    // },
    { label: 'Genre', value: 'gender', colClass: 'xs' },
    { label: 'Nom', value: 'last_name', colClass: 'md' },
    { label: 'Prénom', value: 'first_name', colClass: 'md' },
    { label: 'Date naissance', value: 'birth_date', format: 'year', colClass: 'sm' },
    // { label: 'Adresse', value: 'adresse', colClass: 'xl' },
    // { label: 'Code postal', value: 'code_postal', colClass: 'md' },
    // { label: 'Ville', value: 'city', colClass: 'xl' },
    { label: 'Tarif', value: 'amount_due', colClass: 'sm', suffix: '€' },
    { label: 'Remise totale', value: 'discount_total', colClass: 'sm', suffix: '€', clean0Values: true },
    { label: 'Montant payé', value: 'total_payments', colClass: 'sm', suffix: '€' },
    { label: 'Remb.', value: 'total_refunds', colClass: 'sm', suffix: '€', clean0Values: true },
    { label: 'Trop perçu non remb.', value: 'total_overpayments', colClass: 'sm', suffix: '€' },
    { label: 'Montant restant', value: 'remaining_amount', colClass: 'sm', suffix: '€' },
    { label: 'edit', value: 'edit', colClass: 'xs', canEdit: true },
  ]

  const handleSearch = (e) => {
    setSearch(e.target.value)
  }

  const seasonSelect = 
    <Select
      options={options} onChange={(option) => handleSelect(option, setSelectedSeason)} 
      value={selectedSeason} isClearable={false} 
      placeholder="Choisissez une saison"
      className="select-brief-container" classNamePrefix={'select-brief'} isSearchable={true}
    />

  if (windowWidth <= 1021 || !isAdmin) {
    return (
      <MobileEffective 
        users={users} seasonSelect={seasonSelect}
      />
    )
  }

  const handleReset = () => {
    setSearch('')
  }

  const handleGroupChange = async (item, { action, id_group }) => {
    try {
      await updateUserSeasonGroup({
        id_user_season: item.id_user_season,
        id_user_guest: item.id_user_guest,
        id_group, action,
      }).unwrap();
      toast.success("Groupe mis à jour", { autoClose: 1000, hideProgressBar: true });
    } catch (error) {
      console.log(error);
      toast.error("Erreur lors du changement de groupe");
    }
  };

  const handleClearReview = async (item) => {
    try {
      await updateReviewReason({ review_reason: null, needs_review: false, id_user_season: item.id_user_season }).unwrap();
      toast.success("Review effacée avec succes");
    } catch (error) {
      console.log(error)
      toast.error("Erreur lors de la mise à jour de la review");
    }
  };

  return (
    <>
      {/* <SideBar menus={menus} menuActive={menuActive} setMenuActive={setMenuActive}/> */}
      <div className={`page-container ${openSidebar ? 'open' : 'close'} ${openModalNewUser ? 'pt-0' : ''}`}>
        {!openModalNewUser && 
          <>
            <div className="page-header-line">
              <p className="text-xl font-bold">Liste des inscriptions</p>
              <div className="flex gap-8">
                <Select
                  options={optionTarifs} onChange={(option) => handleSelect(option, setFilterTarif)} 
                  value={filterTarif} isClearable={true} 
                  placeholder="Filtrer par tarif"
                  className="select-group-filter-container" classNamePrefix={'select-group-filter'} isSearchable={true}
                />
                <Select
                  options={optionGroups} onChange={(option) => handleSelect(option, setFilterGroup)} 
                  value={filterGroup} isClearable={true} 
                  placeholder="Filtrer par groupe"
                  className="select-group-filter-container" classNamePrefix={'select-group-filter'} isSearchable={true}
                />
                {!openModalNewUser && 
                  <>
                    <div className="search-container">
                      <i className={'bi bi-search input-icon'}></i>
                      <input  
                        type={'text'} className={`search-input`} autoComplete="off" autoCorrect="off" 
                        placeholder={'Rechercher'} value={search} onChange={handleSearch}
                      />
                      {search.length > 0 && <i className="bi bi-x-lg close-search" onClick={handleReset}></i>}
                    </div>
                    {/* {seasonSelect} */}
                  </>
                }
                <button className="btn-add black" onClick={() => setOpenModalNewUser(true)}>Nouveau</button>
              </div>
            </div>
            <div className="mt-4 flex justify-end gap-8">
              <FilterRows displayUsers={kpiUsers}/>
            </div>
            {hasPendingLicenceChanges && (
              <div className="flex gap-8">
                <button className="btn-add" onClick={handleSaveLicences} disabled={isSavingLicences}>
                  {isSavingLicences 
                    ? 'Enregistrement...' 
                    : `Sauvegarder (${Object.keys(pendingLicences).length})`}
                </button>
                <button className="btn-cancel" onClick={handleCancelLicences} disabled={isSavingLicences}>
                  Annuler
                </button>
              </div>
            )}
            <div className="mt-8">
              <TableBloc
                headers={headers}
                onGroupChange={handleGroupChange}
                data={displayUsers} 
                isFetching={false} isLoading={false} isSuccess={true}
                setOpenModal={setOpenModalNewUser}
                setEdittingUser={setEdittingUser}
                optionGroups={optionGroups}
                pendingLicences={pendingLicences}
                onLicenceChange={handleLicenceChange}
                onClearReview={handleClearReview}
              />
            </div>
          </>
        }
      </div>
      {openModalNewUser && 
        <FormNewUSer 
          openModal={openModalNewUser} setOpenModal={setOpenModalNewUser} id_season={selectedSeason?.value}
          tarifs={tarifs} paymentMethods={paymentMethods} handleCloseModal={handleCloseModal}
          selectedSeason={selectedSeason} optionGroups={optionGroups}
          refetch={refetch} users={users.map(user => ({ label: `${user.last_name} ${user.first_name}`, value: user.id_user }))}
          edittingUser={edittingUser} groups={groups} setEdittingUser={setEdittingUser}
        />
      }      
    </>
  )
}

export default Effectifs